<template lang="pug">
GenericCard.back-order-list(size='auto')
  .d-flex.align-items-center.justify-content-between.p-3
    .d-flex
      .text-large รายการตกค้าง (backorder)
      LoadingIndicator.ml-2(v-if='isLoading')
    CustomDatePicker(v-model='filterDate')
  hr.m-0
  .pt-2.pb-2.px-3
    CustomTable(
      :columns='tableCols'
      :data='tableData'
      @itemClicked='tableItemClicked'
    )
  .sticky-bottom.bg-white
    hr.m-0
    .px-4.py-3
      CustomPagination(
        v-model='currentPage'
        :total='totalPage'
      )
</template>

<script>
/* eslint-disable arrow-body-style */
export default {
  computed: {
    filteredTableData() {
      if (this.tableData) {
        return this.tableData.filter((item) => {
          return (this.filterDate === '') || (this.$dateUtils.isInRange(item.date, this.filterDate));
        });
      }
      return [];
    },
  },
  watch: {
    filterDate() {
      this.currentPage = 1;
      this.loadData();
    },
  },
  data: () => ({
    tableCols: {
      customerName: {
        title: 'ชื่อลูกค้า',
        align: 'left',
        computed: row => (row.customer ? row.customer.name : '-'),
      },
      entryNo: {
        title: 'เลขที่รายการ',
        align: 'left',
        type: 'EntryNo',
      },
      total: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
        // computed(row) {
        //   if (row.products) {
        //     return row.products.reduce((total, prod) => (total + Number(prod.price)), 0);
        //   }
        //   return 0;
        // },
      },
    },
    tableData: [],
    filterDate: '',
    isLoading: false,
    currentPage: 1,
    totalPage: 1,
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // const res = await this.$api.cs.user.backOrderList();
      const res = await this.$api.user.backOrderList(this.currentPage, this.filterDate);
      if (res.status === 200) {
        this.tableData = res.data.data;
        this.currentPage = res.data.current_page;
        this.totalPage = res.data.last_page;
        this.$emit('finishLoading', res.data);
      }

      this.isLoading = false;
    },

    tableItemClicked(e) {
      // const { index, data } = e;
      this.$router.push({
        name: 'cs.sell-record', // can't use path, cause it WON'T allow passing hidden params
        params: {
          order: e.data,
          actionType: 'BACKORDER_LIST',
          // ...e, // pass everything in, LOL
        },
      });
    },
  },
};
</script>

<style lang="scss">
.filter-date {
  font-size: 20px;
}
</style>
